import React, { useState, useEffect } from 'react';
import AsyncSelect from '../Form/AsyncSelector';
import { useEdit } from '../../Services/EditContext';
import { FormValue } from '../Form/FormLabel';
import { useFormikContext } from 'formik';
import ErrorMessage from './ErrorMessage';
const options = [
   
];

const SelectPlace = ({ id,value, autocompletionRequest, onChange, onCoordsChanged , textSearch}) => {
    const selectedOption = { value: value, label: value };
    const [allOps, setAllOps] = useState([selectedOption]);
    const [selectPlacesNode, setPlacesNode] = useState(null);
    const [placesService, setPlacesService] = useState(null);
    const [latLong, setLatLong] = useState({ lat: null, lng: null });
    const { setFieldValue } = useFormikContext(); 
    const { lat, lng } = latLong;
    
    const autocompleteService = new window.google.maps.places.AutocompleteService();
    const [edit] = useEdit();
  
    useEffect(() => {
        if (selectPlacesNode) {
            setPlacesService(new window.google.maps.places.PlacesService(selectPlacesNode));
        }
    }, [selectPlacesNode]);

    const getDetail = (place) => {
        if (placesService && place && place.place_id) {
            try {
                placesService.getDetails(
                    { placeId: place.place_id ,fields:['geometry']},
                    (placeInfo, requestStatus) => {
                        if (requestStatus === 'OK') {
                            const lat = placeInfo.geometry.location.lat();
                            const lng = placeInfo.geometry.location.lng()
                            setLatLong({ lat, lng });
                            setFieldValue(id + 'LatLong', { lat, lng });
                            onCoordsChanged && onCoordsChanged({ lat, lng });
                        } else if (value) {
                            console.warn(
                                `Google Maps Places API RequestStatus is: ${requestStatus}, label property is used`
                            );
                        } else {
                            console.warn(
                                `Google Maps Places API RequestStatus is: ${requestStatus} and label property is missing`
                            );
                        }
                    }
                );
            }
            catch (e) {
                console.warn('Google Maps Places is not loaded', e);
            }
        }
    }


    const handleInputChange =  (place, meta) => {
        
        if (place && meta.action === "input-change") {
            setAllOps([{ label: place, value: selectedOption.value }])
        }
      
    };
    
    const doAutoComplete = (input, callback) => {
        if (autocompleteService) {
            setLatLong({ lat: null, lng: null });
           !textSearch? autocompleteService.getPlacePredictions(
               { input, ...autocompletionRequest },
               predictions => {
                   let options = [];
                   if (predictions) {
                       options = predictions.map(prediction => ({
                           value: prediction.place_id,
                           label: prediction.description,
                           ...prediction
                       }));
                   }
                   callback(options);
               }
           ) :
               placesService.textSearch({
                   query: input,
                   ...autocompletionRequest
               },
                   predictions => {
                       let options = [];
                       if (predictions) {
                           options = predictions.map(prediction => {
                               return {
                                   value: prediction.name,
                                   label: prediction.name,
                                   description: prediction.name,
                                   ...prediction
                               }
                           });
                       }
                       callback(options);
                   })
       }
        
    };
    const onSelectChange = (c) => {
        getDetail(c);
        onChange(c);

    }
    return (<React.Fragment>
        {edit ? <AsyncSelect
            id={id}
            defaultValue={selectedOption}
            defaultOptions={options}
            loadOptions={doAutoComplete}
            defaultInputValue={selectedOption.label}
            onInputChange={handleInputChange}
            onChange={onSelectChange}
            options={allOps} /> : <FormValue>{selectedOption.label}</FormValue>
        } <div ref={node => setPlacesNode(node)} />
        <ErrorMessage name={id} />
        {lat ? <FormValue>Lat:{lat}</FormValue>:null}{lng?<FormValue>Long:{lng}</FormValue>:null}
        </React.Fragment>
    );
};

export default SelectPlace;


